export default "__VITE_ASSET__BFtokxUD__"